import React from "react";

const Close = ({style = {}, size = "36", className = "", fill = "#73788B", stroke="73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path className="u_fill-stroke"
            d="M18 14.557L7.08 3.637l-.142-.142-.142.141-3.16 3.16-.141.142.141.141L14.557 18 3.637 28.92l-.142.142.141.142 3.16 3.16.142.141.141-.141L18 21.443l10.92 10.92.142.142.142-.141 3.16-3.16.141-.142-.141-.141L21.443 18l10.92-10.922.142-.141-.141-.142-3.16-3.16-.142-.141-.141.141L18 14.557z"
            stroke={stroke}
            fill={fill}
            strokeWidth={0.4}
        />
    </svg>
);

export default Close;

